import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox, InfoIcon, Typography } from 'seagull';
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import PreapprovedTextField from "./PreapprovedTextField";
import styles from "./ServiceBuilder.module.scss";
import { getPreapprovedSuffix } from "./ServiceBuilder.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function PreapprovedAmountSection() {
  const {
    PREAPPROVED_AMOUNT_IMPROVMENTS
  } = useFeatureFlags();
  const {
    watch,
    setValue
  } = useFormContext();
  const [isPreapprovedEnabled, setIsPreapprovedEnabled] = useState(false);
  const [suffixAmount, setSuffixAmount] = useState('');
  const [unitCap, recurrencePeriod] = watch(['unitCap', 'recurrencePeriod']);
  useEffect(() => {
    if (unitCap && unitCap.trim() !== '' && +unitCap > 0) {
      setIsPreapprovedEnabled(true);
    }
  }, [unitCap]);
  useEffect(() => {
    const suffix = getPreapprovedSuffix(recurrencePeriod);
    setSuffixAmount(suffix);
  }, [recurrencePeriod]);
  const handlePreapprovedCheckboxChange = checked => {
    setIsPreapprovedEnabled(checked);
    if (!checked) {
      setValue('unitCap', '', {
        shouldDirty: true
      });
    } else {
      const currentValue = watch('unitCap');
      if (currentValue === '0') {
        setValue('unitCap', '', {
          shouldDirty: true
        });
      }
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.preapprovedSection,
    children: PREAPPROVED_AMOUNT_IMPROVMENTS ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.checkboxRow,
        children: [/*#__PURE__*/_jsx(Checkbox, {
          checked: isPreapprovedEnabled,
          onChange: e => handlePreapprovedCheckboxChange(e.target.checked),
          "data-testid": "preapproved-amount-checkbox"
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          onClick: () => handlePreapprovedCheckboxChange(!isPreapprovedEnabled),
          style: {
            cursor: 'pointer'
          },
          children: "Set a preapproved amount"
        }), /*#__PURE__*/_jsx(InfoIcon, {
          "data-testid": "sb-cap-info",
          info: /*#__PURE__*/_jsx("div", {
            "data-testid": "sb-cap-tooltip",
            children: "Charging a client up to the preapproved amount for the period doesn't require their approval. If no amount is set, or if the charge exceeds the limit, client approval will be required."
          })
        })]
      }), isPreapprovedEnabled && /*#__PURE__*/_jsx(PreapprovedTextField, {
        suffix: suffixAmount
      })]
    }) : /*#__PURE__*/_jsx(PreapprovedTextField, {})
  });
}